module.exports = __webpack_public_path__ + "static/media/brooke-unsplash.f773ffc7.jpg";